import {GetterTree, MutationTree, ActionTree} from 'vuex'
import {GroupsState, Room} from '@/store/types'
import axios from 'axios'

type GroupsGetter = GetterTree<GroupsState, any>
type GroupsMutation = MutationTree<GroupsState>
type GroupsAction = ActionTree<GroupsState, any>

const state: GroupsState = {
    groups: [],
    activeGroups: [],
}

const getters: GroupsGetter = {
    groups: (state) => state.groups,
    activeGroups: (state) => state.activeGroups,
}

const mutations: GroupsMutation = {
    setGroups: (state, groups) => {
        state.groups = groups
    },
    setActiveGroups: (state, id) => {
        state.activeGroups = state.groups.filter((group) => {
            return group.rooms.filter((s: Room) => s.id === id).length
        })
    },
}

const actions: GroupsAction = {
    getGroups: ({commit}) => {
        return new Promise((resolve, reject) => {
            axios.get('inventory-groups').then((response) => {
                commit('setGroups', response.data.data)
                resolve(response.data.data)
            }).catch((error) => {
                reject(error)
            })
        })
    },
}

export default {
    state,
    getters,
    mutations,
    actions,
}
